<template>
    <EditingDialog 
        :context="context"
        :additionalAfterSaveFunction="saveSubCatalogues"
        :disabled="isSaveDisabled"
    >
        <template v-slot:editForm>
            <v-row>
                <v-col>
                    <BaseEditPageAutocomplete 
                        :context="context"
                        field="Licensor"
                        :label="$t('lang_GENERIC_CAPTION_LICENSOR')"
                        rules="required"
                        :withFreeText="false"
                        :withMargin="false"
                        :alvqa="alvqa + '-autocomplete-licensor-textfield'"
                    >
                        <template v-slot:selection="{ item }">
                            <div class="ellipsis" :alvqa="alvqa + '-autocomplete-licensor-selection'">
                                {{ item.gemaName }}
                                <span v-if="$alvPlugin.printName(item)">
                                    ({{ item.firstName }} {{ item.lastName }})
                                </span>
                            </div>
                        </template>
                        <template v-slot:items="{ items }">
                            <v-list-item-content :alvqa="alvqa + '-autocomplete-licensor-dropdown-' + items.alvId">
                                <v-list-item-title :alvqa="alvqa + '-autocomplete-licensor-dropdown-' + items.alvId + '-title'">
                                    {{ items.gemaName }}
                                    {{ $alvPlugin.printName(items) ? '(' + items.firstName + ' ' + items.lastName +')' : ''}}
                                        <v-avatar color="grey" size="20" class="caption">{{ items.typeOfAz }}</v-avatar>
                                </v-list-item-title>
                                <v-list-item-subtitle :alvqa="alvqa + '-autocomplete-licensor-dropdown-' + items.alvId + '-subtitle'">
                                    {{ $t('lang_IPI') }}: {{ items.ipi !== '' ? items.ipi : $t('lang_GENERIC_CAPTION_NONE') }} | {{ items.alvId }}
                                </v-list-item-subtitle>
                            </v-list-item-content>
                        </template>
                    </BaseEditPageAutocomplete>
                </v-col>
            </v-row>
            <v-row>
                <v-col>
                    <BaseEditPageTextField 
                        :context="context"
                        field="AgreementNumber"
                        :label="$t('lang_CONTRACTS_PUBLISHING_CAPTION_AGREEMENT_NUMBER')"
                        :withMargin="false"
                        :alvqa="alvqa + '-textfield-agreement-number'"
                        :disabled="true"
                        :readonly="true"
                        :clearable="false"
                    />
                </v-col>
                <v-col>
                    <BaseEditPageTextField 
                        :context="context"
                        field="ScheduleNumber"
                        :label="$t('lang_CONTRACTS_PUBLISHING_CAPTION_SCHEDULE_NUMBER')"
                        :withMargin="false"
                        :alvqa="alvqa + '-textfield-schedule-number'"
                    />
                </v-col>
            </v-row>
            <v-row>
                <v-col>
                    <BaseEditPageDatePicker 
                        :context="context"
                        field="ValidUntil"
                        :label="$t('lang_GENERIC_CAPTION_LICENSABLE_UNTIL')"
                        :withMargin="false"
                        :alvqa="alvqa + '-datepicker-valid-until'"
                    />
                </v-col>
                <v-col>
                    <BaseEditPageDatePicker 
                        :context="context"
                        field="ProcessableUntil"
                        :label="$t('lang_GENERIC_CAPTION_PROCESSABLE_UNTIL')"
                        :withMargin="false"
                        :alvqa="alvqa + '-datepicker-processable-until'"
                    />
                </v-col>
            </v-row>
            <v-row v-if="isSaveDisabled">
                <v-col>
                    <v-alert type="error" dense text>
                        {{ $t('lang_CONTRACTS_PUBLISHING_ERROR_PROCESSABLE_BEFORE_VALID') }}
                    </v-alert>
                </v-col>
            </v-row>
            <v-row>
                <v-col>
                    <BaseEditPageTextarea 
                        :label="$t('lang_GENERAL_CAPTION_NOTES')"
                        field="Notes"
                        :context="context"
                        :withMargin="false"
                        :alvqa="alvqa + '-textarea-notes'"
                    />
                </v-col>
            </v-row>
        </template>
    </EditingDialog>
</template>

<script>
import EditingDialog from '@/components/_dialogs/EditingDialog'
import BaseEditPageAutocomplete from '@/components/_editForm/BaseEditPageAutocomplete'
import BaseEditPageTextField from '@/components/_editForm/BaseEditPageTextField'
import BaseEditPageTextarea from '@/components/_editForm/BaseEditPageTextarea'
import BaseEditPageDatePicker from '@/components/_editForm/BaseEditPageDatePicker'

export default {
    name: "PublishingContractsSubCataloguesReadOnlyDialog",
    components: {
        EditingDialog,
        BaseEditPageAutocomplete,
        BaseEditPageTextField,
        BaseEditPageTextarea,
        BaseEditPageDatePicker
    },
    data() {
        return {
            context: "PublishingContractsSubCatalogues",
            alvqa: 'publishing-contracts-list-row-' + this.contractAvlId + '-read-only-panel-sub-catalogues-editing-dialog'
        }
    },
    computed: {
        editingDetails() {
            return this.$store.getters.getPublishingContractsSubCataloguesEditingDialogDetails || {}
        },
        isSaveDisabled() {
            const vu = this.editingDetails.validUntil
            const pu = this.editingDetails.processableUntil
            if (!vu || !pu) return false
            return new Date(pu) < new Date(vu)
        }
    },
    methods: {
        saveSubCatalogues() {
            this.$store.dispatch('savePublishingContractsSubCatalogues')
        }
    }
}
</script>